import {
  POST_STATIONS_CATALOG,
  POST_STATIONS_CATALOG_SUCCESS,
  POST_STATIONS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const putStationsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case POST_STATIONS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case POST_STATIONS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case POST_STATIONS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
